import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../components/home/Navbar";
import HeroSection from "../components/home/HeroSection";
import SearchFilter from "../components/home/SearchFilter";
import StatsCards from "../components/home/StatsCards";
import Footer from "../components/home/Footer";
import ForumPage from "../pages/forum/ForumPage";
import ConnexionPage from "../pages/login/ConnexionPage"

// Forum
import ForumTopicList from "../pages/forum/ForumTopicList";

import "../styles/HomePage.css";

export default function HomePage() {

    return (
        <>

            <HeroSection />
            <ConnexionPage />
            <ForumPage />

            <StatsCards />

            <Footer />
        </>
    );
}